/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_New_Networks_DiscordInputs */

const fr_help_new_networks_discord = /** @type {(inputs: Help_New_Networks_DiscordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toute suggestion d'ajout de réseau doit être faite sur le serveur Discord dédié.`)
};

const en_help_new_networks_discord = /** @type {(inputs: Help_New_Networks_DiscordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Any suggestion to add a network must be made on the dedicated Discord server.`)
};

/**
* | output |
* | --- |
* | "Any suggestion to add a network must be made on the dedicated Discord server." |
*
* @param {Help_New_Networks_DiscordInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const help_new_networks_discord = /** @type {((inputs?: Help_New_Networks_DiscordInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_New_Networks_DiscordInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_help_new_networks_discord(inputs)
	return en_help_new_networks_discord(inputs)
});